import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CCD99C36-5D88-4696-8193-56F11C4B20A7
 * name border-color
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/border-color.svg
 * tags
 * - Color 
 * - Text / Content / Format 
 */
export const BorderColorIcon = createSvgIcon(<><path d="M20.71,4.04C21.1,3.65 21.1,3 20.71,2.63L18.37,0.29C18,-0.1 17.35,-0.1 16.96,0.29L15,2.25L18.75,6M17.75,7L14,3.25L4,13.25V17H7.75L17.75,7Z" /></>, 'BorderColorIcon');
export default BorderColorIcon